var qe = Object.defineProperty;
var be = (e, r, t) => r in e ? qe(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var S = (e, r, t) => (be(e, typeof r != "symbol" ? r + "" : r, t), t);
import { jsx as c, jsxs as q, Fragment as k } from "react/jsx-runtime";
import Se, { createContext as Ae, forwardRef as Le, useState as X, useRef as x, useEffect as ge, Suspense as Te } from "react";
import * as Oe from "@tanstack/react-query";
import { useSuspenseQuery as Be, dehydrate as Ve, hydrate as ze, QueryClientProvider as De, QueryClient as Ue } from "@tanstack/react-query";
import { I18nextProvider as je, useTranslation as Ce } from "react-i18next";
import "i18next";
const xe = ({ children: e, i18nInstance: r }) => /* @__PURE__ */ c(je, { i18n: r, children: e }), We = (e = "label") => {
  const r = Array.isArray(e) ? e : [e];
  return Ce(r);
};
var b = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ke = typeof b == "object" && b && b.Object === Object && b, Pe = typeof self == "object" && self && self.Object === Object && self;
Ke || Pe || Function("return this")();
/*! js-cookie v3.0.5 | MIT */
function U(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r];
    for (var o in t)
      e[o] = t[o];
  }
  return e;
}
var Ne = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Y(e, r) {
  function t(n, s, A) {
    if (!(typeof document > "u")) {
      A = U({}, r, A), typeof A.expires == "number" && (A.expires = new Date(Date.now() + A.expires * 864e5)), A.expires && (A.expires = A.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var g = "";
      for (var C in A)
        A[C] && (g += "; " + C, A[C] !== !0 && (g += "=" + A[C].split(";")[0]));
      return document.cookie = n + "=" + e.write(s, n) + g;
    }
  }
  function o(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], A = {}, g = 0; g < s.length; g++) {
        var C = s[g].split("="), i = C.slice(1).join("=");
        try {
          var a = decodeURIComponent(C[0]);
          if (A[a] = e.read(i, a), n === a)
            break;
        } catch {
        }
      }
      return n ? A[n] : A;
    }
  }
  return Object.create(
    {
      set: t,
      get: o,
      remove: function(n, s) {
        t(
          n,
          "",
          U({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return Y(this.converter, U({}, this.attributes, n));
      },
      withConverter: function(n) {
        return Y(U({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(r) },
      converter: { value: Object.freeze(e) }
    }
  );
}
Y(Ne, { path: "/" });
Ae({});
function _(e) {
  return e.toLowerCase().split(" ").map(function(r) {
    return r.replace(r[0], r[0].toUpperCase());
  }).join(" ");
}
Ae({
  pageUrl: ""
});
function Ye({
  apiKey: e,
  clickoutOrigin: r,
  clickoutServiceUrl: t,
  deviceType: o,
  fullPageUrl: n,
  gtmId: s,
  offers: A,
  pageUrl: g,
  recommendedMarketId: C,
  shouldUseClickoutService: i
}) {
  return !i || !t ? A ?? [] : A != null && A.length ? A.map((a, f) => {
    const d = {
      apiKey: e,
      clickoutOrigin: r,
      containerId: s,
      deviceType: o,
      fullPageUrl: n,
      offerId: String(a == null ? void 0 : a.id),
      offerPosition: String(f),
      pageUrl: g,
      recommendedMarketId: C
    }, l = new URL(t), w = l.searchParams;
    for (const [p, y] of Object.entries(d))
      y != null && w.set(p, y);
    return l.search = w.toString(), {
      ...a,
      clickOutUrl: l.toString()
    };
  }) : [];
}
function Ie(e) {
  var r, t, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var n = e.length;
      for (r = 0; r < n; r++)
        e[r] && (t = Ie(e[r])) && (o && (o += " "), o += t);
    } else
      for (t in e)
        e[t] && (o && (o += " "), o += t);
  return o;
}
function V() {
  for (var e, r, t = 0, o = "", n = arguments.length; t < n; t++)
    (e = arguments[t]) && (r = Ie(e)) && (o && (o += " "), o += r);
  return o;
}
const F = /{{([^{{}}]*)}}/g, Fe = (e) => e.replace(/[ /-]+/g, "_").replace(/[^a-zA-Z0-9_]/g, "").replace(/_+/g, "_").toUpperCase(), ke = ({ marketName: e, t: r }) => {
  const o = `CX_MARKET_TYPE_${Fe(e)}`, n = r(o, { ns: "label" });
  return n === o ? e : n;
}, Xe = (e) => {
  const r = e.match(new RegExp("(?<=\\s)(at\\.|vs\\.?|@|v\\.?|at)(?=\\s)", "i"));
  if (!r)
    return null;
  const t = r[1], o = e.split(new RegExp(`\\s${t.replace(".", "\\.")}\\s`, "i")).map((n) => n.trim());
  return o.length === 2 ? { parts: o, separator: t } : null;
}, Je = (e, r, t) => typeof e != "string" ? "" : r == null || typeof r != "object" ? e : RegExp(F.source).test(e) ? e.replace(F, (o, n) => {
  const s = n.trim().split(/\./);
  let A = r;
  for (let g = 0; g < s.length; g += 1) {
    if (A[s[g]] == null)
      return o;
    A = A[s[g]];
  }
  if (typeof A == "string") {
    const { SPORT: g = "" } = r, C = g == null ? void 0 : g.toLowerCase();
    switch (s[0]) {
      case "EVENT":
        return !C || !t ? A : t(A, {
          ns: C
        });
      case "MARKET":
        return t ? ke({
          marketName: A,
          t
        }) : A;
      case "SPORT":
        return t ? t(_(A), {
          ns: "label"
        }) : A;
      case "SUBEVENT": {
        const i = Xe(A);
        if (i) {
          const [a, f] = i.parts.map((l) => t ? t(l ? _(l) : "", {
            ns: C
          }) : l);
          return `${a} ${i.separator} ${f}`;
        }
        return A;
      }
      default:
        return A;
    }
  }
  return o;
}) : e, ie = (e = "") => {
  if (typeof e != "string" || !e.trim())
    return {};
  const r = "|", t = e.split(r).map((o) => o.trim().split("=").map((n) => n.trim()));
  return Object.fromEntries(t);
}, He = ({
  fallbackString: e = "",
  placeholdersString: r,
  subjectString: t,
  translatorFunction: o
}) => {
  const n = ie(r), s = Je(t, n, o);
  return RegExp(F.source).test(s) && e || s;
}, $ = ({
  placeholders: e,
  template: r = "",
  translatorFunction: t,
  value: o = ""
}) => !r || !e ? o : o && He({
  fallbackString: o.trim(),
  placeholdersString: e,
  subjectString: r.trim(),
  translatorFunction: t
}), Qe = (e) => {
  if (!e)
    return "";
  const r = new URL(e);
  return r.searchParams.append("fm", "webp"), r.searchParams.append("w", "224"), r.toString();
}, Ze = ({
  analyticsDataLayer: e,
  bookmakerCode: r,
  disableAnalytics: t,
  offerClickoutUrl: o,
  offerIndex: n,
  offerTitle: s
}, A, g) => {
  const C = (f) => !t && Array.isArray(f);
  return {
    handleClickout: (f) => {
      f.preventDefault(), C(e) && e.push({
        action: "offers_clickout",
        bookieCode: r,
        category: "Widget",
        event: "cta_clickout",
        label: "claim_offer",
        offerIndex: n + 1,
        offerName: s,
        page: window.location.href,
        variation: "default"
      }), window.open(o, "_blank", "noopener noreferrer");
    },
    handleTermsToggle: (f) => {
      f.preventDefault();
      const d = !!A;
      C(e) && e.push({
        action: "T&Cs",
        bookieCode: r,
        category: "Widget",
        event: d ? "offer_TCs_close" : "offer_TCs_open",
        offerIndex: n + 1,
        offerName: s,
        page: window.location.href,
        variation: "default"
      }), g(!d);
    }
  };
}, _e = (e) => {
  if (!e)
    return;
  const r = ie(e), t = Object.keys(r);
  return t.length ? [
    ...new Set(
      t.map((o) => {
        var n;
        switch (o) {
          case "SUBEVENT":
          case "EVENT":
            return (n = r.SPORT) == null ? void 0 : n.toLowerCase();
          case "SPORT":
          case "MARKET":
            return "label";
          default:
            return;
        }
      }).filter((o) => o !== void 0)
    )
  ] : e;
}, $e = "_offer_1v3ls_45", er = "_offerTermsExpanded_1v3ls_67", rr = "_offerOnlyChild_1v3ls_71", tr = "_offerHeaderWithLabel_1v3ls_77", or = "_offerFeaturedLabel_1v3ls_81", nr = "_offerFeaturedLabelContent_1v3ls_90", sr = "_offerTruncateText_1v3ls_129", Ar = "_offerBookmakerLogo_1v3ls_135", gr = "_offerBody_1v3ls_144", Cr = "_offerBodyContent_1v3ls_157", Ir = "_offerShortTerms_1v3ls_164", ir = "_offerTitle_1v3ls_172", cr = "_offerSummary_1v3ls_181", lr = "_offerHeader_1v3ls_77", ar = "_offerClaimCta_1v3ls_219", fr = "_offerFooter_1v3ls_240", ur = "_offerTermsCta_1v3ls_251", dr = "_offerTermsCtaIcon_1v3ls_276", hr = "_offerTermsCtaTermsOpen_1v3ls_285", pr = "_offerFullTerms_1v3ls_289", wr = "_offerFullTermsNoTerms_1v3ls_308", v = {
  offer: $e,
  offerTermsExpanded: er,
  offerOnlyChild: rr,
  offerHeaderWithLabel: tr,
  offerFeaturedLabel: or,
  offerFeaturedLabelContent: nr,
  offerTruncateText: sr,
  offerBookmakerLogo: Ar,
  offerBody: gr,
  offerBodyContent: Cr,
  offerShortTerms: Ir,
  offerTitle: ir,
  offerSummary: cr,
  offerHeader: lr,
  offerClaimCta: ar,
  offerFooter: fr,
  offerTermsCta: ur,
  offerTermsCtaIcon: dr,
  offerTermsCtaTermsOpen: hr,
  offerFullTerms: pr,
  offerFullTermsNoTerms: wr
}, yr = (e) => /* @__PURE__ */ c(
  "svg",
  {
    className: v.offerTermsCtaIcon,
    fill: "currentColor",
    height: 16,
    viewBox: "0 0 512 512",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ c("path", { d: "m98 190.06 139.78 163.12a24 24 0 0 0 36.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z" })
  }
), ce = Le(
  ({
    analyticsDataLayer: e,
    autoExpandedTermsAndConditions: r,
    bookmaker: t,
    clickOutUrl: o = "",
    disableAnalytics: n,
    displayTitle: s,
    displayTitleTemplate: A = "",
    featuredLabels: g,
    fullTerms: C,
    id: i,
    isOnlyChild: a,
    offerCta: f,
    offerCtaTemplate: d,
    offerIndex: l,
    placeholders: w = "",
    shortTerms: p,
    summary: y,
    termsCtaLabel: m
  }, G) => {
    const I = _e(w), { t: u } = Ce(I ?? ["label"]), [h, R] = X(!!r), M = (t == null ? void 0 : t.feedsCode) ?? "", E = (t == null ? void 0 : t.displayName) || "", z = (t == null ? void 0 : t.primaryColor) || "#ffffff", K = t == null ? void 0 : t.logoFull, ye = Qe(K == null ? void 0 : K.url), P = g, N = $({
      placeholders: w,
      template: A,
      translatorFunction: u,
      value: s
    }), H = $({
      placeholders: w,
      template: d,
      translatorFunction: u,
      value: f
    }), Q = y || "", D = C || "", Z = p || "", { handleClickout: me, handleTermsToggle: ve } = Ze(
      {
        analyticsDataLayer: e,
        bookmakerCode: M,
        disableAnalytics: n,
        offerClickoutUrl: o,
        offerIndex: l,
        offerTitle: N
      },
      h,
      R
    ), Ge = V(v.offer, {
      [v.offerTermsExpanded]: h,
      [v.offerOnlyChild]: a
    }), Re = V(v.offerHeader, {
      [v.offerHeaderWithLabel]: P
    }), Ee = V(v.offerTermsCta, {
      [v.offerTermsCtaTermsOpen]: h && D
    }), Me = V(v.offerFullTerms, {
      [v.offerFullTermsNoTerms]: !D
    });
    return /* @__PURE__ */ q("div", { className: Ge, "data-offer-id": i, "data-offer-index": l, ref: G, children: [
      /* @__PURE__ */ q("div", { className: Re, style: { backgroundColor: z }, children: [
        P && /* @__PURE__ */ c("div", { className: v.offerFeaturedLabel, children: /* @__PURE__ */ c("div", { className: v.offerFeaturedLabelContent, children: /* @__PURE__ */ c("div", { className: v.offerTruncateText, children: P }) }) }),
        /* @__PURE__ */ c(
          "img",
          {
            alt: E || M,
            className: v.offerBookmakerLogo,
            "data-bookmaker-code": M,
            src: ye
          }
        )
      ] }),
      /* @__PURE__ */ q("div", { className: v.offerBody, children: [
        /* @__PURE__ */ q("div", { className: v.offerBodyContent, children: [
          Z && /* @__PURE__ */ c("div", { className: v.offerShortTerms, children: Z }),
          N && /* @__PURE__ */ c("h5", { className: v.offerTitle, children: N }),
          Q && /* @__PURE__ */ c("div", { className: v.offerSummary, dangerouslySetInnerHTML: { __html: Q } })
        ] }),
        o && H && /* @__PURE__ */ c("a", { className: v.offerClaimCta, href: o, onClick: me, children: H })
      ] }),
      /* @__PURE__ */ c("div", { className: v.offerFooter, children: /* @__PURE__ */ q("button", { className: Ee, disabled: !D, onClick: ve, children: [
        /* @__PURE__ */ c("span", { children: m }),
        /* @__PURE__ */ c(yr, {})
      ] }) }),
      h && /* @__PURE__ */ c("div", { className: Me, children: /* @__PURE__ */ c("div", { dangerouslySetInnerHTML: { __html: D } }) })
    ] });
  }
);
ce.displayName = "Card";
var mr = function() {
  const r = Array.prototype.slice.call(arguments).filter(Boolean), t = {}, o = [];
  r.forEach((s) => {
    (s ? s.split(" ") : []).forEach((g) => {
      if (g.startsWith("atm_")) {
        const [, C] = g.split("_");
        t[C] = g;
      } else
        o.push(g);
    });
  });
  const n = [];
  for (const s in t)
    Object.prototype.hasOwnProperty.call(t, s) && n.push(t[s]);
  return n.push(...o), n.join(" ");
}, vr = mr;
const Gr = ({ count: e, ref: r, setter: t }) => {
  const o = x(null);
  return ge(() => {
    var n;
    if (!(!r.current || !("ResizeObserver" in window)))
      return o.current = new ResizeObserver((s) => {
        var a, f;
        const A = s == null ? void 0 : s[0], g = A == null ? void 0 : A.target, C = (g == null ? void 0 : g.scrollWidth) > (((f = (a = A == null ? void 0 : A.borderBoxSize) == null ? void 0 : a[0]) == null ? void 0 : f.inlineSize) || (g == null ? void 0 : g.clientWidth)), i = e > 1;
        t(!C || !i);
      }), o.current !== null && ((n = o == null ? void 0 : o.current) == null || n.observe(r.current)), () => {
        var s;
        (s = o == null ? void 0 : o.current) == null || s.disconnect();
      };
  }, [r, e, t]), {
    observer: o.current
  };
}, Rr = "_container_12g3y_1", Er = "_footerCentred_12g3y_14", Mr = "_controls_12g3y_18", qr = "_poweredByContainer_12g3y_37", j = {
  container: Rr,
  footerCentred: Er,
  controls: Mr,
  poweredByContainer: qr
}, br = (e) => /* @__PURE__ */ q("svg", { height: 18, viewBox: "0 0 512 512", width: 18, xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ c("title", { children: "Arrow Back" }),
  /* @__PURE__ */ c(
    "path",
    {
      d: "M244 400 100 256l144-144M120 256h292",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 48
    }
  )
] }), Sr = (e) => /* @__PURE__ */ q("svg", { height: 18, viewBox: "0 0 512 512", width: 18, xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ c("title", { children: "Arrow Forward" }),
  /* @__PURE__ */ c(
    "path",
    {
      d: "m268 112 144 144-144 144m124-144H100",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 48
    }
  )
] }), Lr = ({
  handleLeftArrow: e,
  handleRightArrow: r,
  hideControls: t = !1,
  offerCount: o,
  poweredBy: n
}) => {
  const s = typeof n == "string" && n.length > 0 || typeof n == "object";
  return /* @__PURE__ */ q(
    "footer",
    {
      className: V(j.container, {
        [j.footerCentred]: o < 2
      }),
      children: [
        /* @__PURE__ */ c("div", { className: j.poweredByContainer, children: s ? n : null }),
        !t && /* @__PURE__ */ q("div", { className: j.controls, children: [
          /* @__PURE__ */ c("button", { onClick: e, children: /* @__PURE__ */ c(br, {}) }),
          /* @__PURE__ */ c("button", { onClick: r, children: /* @__PURE__ */ c(Sr, {}) })
        ] })
      ]
    }
  );
}, Tr = "_container_xm9ij_1", Or = {
  container: Tr
}, Br = ({
  children: e,
  containerRef: r,
  hiddenControls: t = !1,
  offerCount: o,
  poweredBy: n
}, s) => {
  const [A, g] = X(t);
  Gr({
    count: o,
    ref: r,
    setter: g
  });
  const C = (i) => () => {
    var d;
    const f = (s && "current" in s && "base" in s.current ? s.current.base : s.current).getBoundingClientRect().width ?? 0;
    (d = r == null ? void 0 : r.current) == null || d.scrollBy({
      behavior: "smooth",
      left: (f + 16) * (i === "left" ? -1 : 1)
    });
  };
  return /* @__PURE__ */ q(k, { children: [
    /* @__PURE__ */ c("div", { className: vr(Or.container), "data-testid": "offers-carousel", ref: r, children: e }),
    /* @__PURE__ */ c(
      Lr,
      {
        handleLeftArrow: C("left"),
        handleRightArrow: C("right"),
        hideControls: A,
        offerCount: o,
        poweredBy: n
      }
    )
  ] });
}, Vr = Se.forwardRef(Br);
function zr(e, r) {
  ge(() => {
    if (typeof window > "u" || !e.current)
      return;
    const t = new IntersectionObserver(([o]) => {
      o.isIntersecting && (r == null || r(), t.disconnect());
    });
    return t.observe(e.current), () => {
      t.disconnect();
    };
  }, [e, r]);
}
const Dr = (e, r) => ({
  trackImpression: (o) => {
    e || !Array.isArray(r) || r.push(o);
  }
}), Ur = "application/json", le = "Content-Type", O = Symbol(), ae = Symbol();
function ee(e = {}) {
  var r;
  const t = e instanceof Array ? Object.fromEntries(e) : e;
  return (r = Object.entries(t).find(([o]) => o.toLowerCase() === le.toLowerCase())) === null || r === void 0 ? void 0 : r[1];
}
function re(e) {
  return /^application\/.*json.*/.test(e);
}
const T = function(e, r, t = !1) {
  return Object.entries(r).reduce((o, [n, s]) => {
    const A = e[n];
    return Array.isArray(A) && Array.isArray(s) ? o[n] = t ? [...A, ...s] : s : typeof A == "object" && typeof s == "object" ? o[n] = T(A, s, t) : o[n] = s, o;
  }, { ...e });
}, B = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, r = !0, t = !1, ...o) {
    const n = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (r && !n)
      throw new Error(e + " is not defined");
    return t && n ? new n(...o) : n;
  }
};
function jr(e, r = !1) {
  B.options = r ? e : T(B.options, e);
}
function xr(e, r = !1) {
  B.polyfills = r ? e : T(B.polyfills, e);
}
function Wr(e) {
  B.errorType = e;
}
const Kr = (e) => (r) => e.reduceRight((t, o) => o(t), r) || r;
class fe extends Error {
}
const Pr = (e) => {
  const r = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((I, u) => u.beforeRequest && u.beforeRequest(I, e._options, r) || I, e);
  const { _url: t, _options: o, _config: n, _catchers: s, _resolvers: A, _middlewares: g, _addons: C } = e, i = new Map(s), a = T(n.options, o);
  let f = t;
  const d = Kr(g)((I, u) => (f = I, n.polyfill("fetch")(I, u)))(t, a), l = new Error(), w = d.catch((I) => {
    throw { [O]: I };
  }).then((I) => {
    var u;
    if (!I.ok) {
      const h = new fe();
      if (h.cause = l, h.stack = h.stack + `
CAUSE: ` + l.stack, h.response = I, h.status = I.status, h.url = f, I.type === "opaque")
        throw h;
      const R = n.errorType === "json" || ((u = I.headers.get("Content-Type")) === null || u === void 0 ? void 0 : u.split(";")[0]) === "application/json";
      return (n.errorType ? R ? I.text() : I[n.errorType]() : Promise.resolve(I.body)).then((E) => {
        throw h.message = typeof E == "string" ? E : I.statusText, E && (R && typeof E == "string" ? (h.text = E, h.json = JSON.parse(E)) : h[n.errorType] = E), h;
      });
    }
    return I;
  }), p = (I) => I.catch((u) => {
    const h = Object.prototype.hasOwnProperty.call(u, O), R = h ? u[O] : u, M = (R == null ? void 0 : R.status) && i.get(R.status) || i.get(R == null ? void 0 : R.name) || h && i.has(O) && i.get(O);
    if (M)
      return M(R, e);
    const E = i.get(ae);
    if (E)
      return E(R, e);
    throw R;
  }), y = (I) => (u) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ p(I ? w.then((h) => h && h[I]()).then((h) => u ? u(h) : h) : w.then((h) => u ? u(h) : h)), m = {
    _wretchReq: e,
    _fetchReq: d,
    _sharedState: r,
    res: y(null),
    json: y("json"),
    blob: y("blob"),
    formData: y("formData"),
    arrayBuffer: y("arrayBuffer"),
    text: y("text"),
    error(I, u) {
      return i.set(I, u), this;
    },
    badRequest(I) {
      return this.error(400, I);
    },
    unauthorized(I) {
      return this.error(401, I);
    },
    forbidden(I) {
      return this.error(403, I);
    },
    notFound(I) {
      return this.error(404, I);
    },
    timeout(I) {
      return this.error(408, I);
    },
    internalError(I) {
      return this.error(500, I);
    },
    fetchError(I) {
      return this.error(O, I);
    }
  }, G = C.reduce((I, u) => ({
    ...I,
    ...typeof u.resolver == "function" ? u.resolver(I) : u.resolver
  }), m);
  return A.reduce((I, u) => u(I, e), G);
}, Nr = {
  _url: "",
  _options: {},
  _config: B,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, r = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: r ? e : T(this._config.polyfills, e)
      }
    };
  },
  url(e, r = !1) {
    if (r)
      return { ...this, _url: e };
    const t = this._url.split("?");
    return {
      ...this,
      _url: t.length > 1 ? t[0] + e + "?" + t[1] : this._url + e
    };
  },
  options(e, r = !1) {
    return { ...this, _options: r ? e : T(this._options, e) };
  },
  headers(e) {
    const r = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: T(this._options, { headers: r }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [le]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, r) {
    const t = new Map(this._catchers);
    return t.set(e, r), { ...this, _catchers: t };
  },
  catcherFallback(e) {
    return this.catcher(ae, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, r = !1) {
    return { ...this, _resolvers: r ? [e] : [...this._resolvers, e] };
  },
  defer(e, r = !1) {
    return {
      ...this,
      _deferred: r ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, r = !1) {
    return {
      ...this,
      _middlewares: r ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, r = "", t = null) {
    let o = this.url(r).options({ method: e });
    const n = ee(o._options.headers), s = this._config.polyfill("FormData", !1), A = typeof t == "object" && !(s && t instanceof s) && (!o._options.headers || !n || re(n));
    return o = t ? A ? o.json(t, n) : o.body(t) : o, Pr(o._deferred.reduce((g, C) => C(g, g._url, g._options), o));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, r = "") {
    return this.fetch("PUT", r, e);
  },
  post(e, r = "") {
    return this.fetch("POST", r, e);
  },
  patch(e, r = "") {
    return this.fetch("PATCH", r, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, r) {
    const t = ee(this._options.headers);
    return this.content(r || re(t) && t || Ur).body(JSON.stringify(e));
  }
};
function L(e = "", r = {}) {
  return { ...Nr, _url: e, _options: r };
}
L.default = L;
L.options = jr;
L.errorType = Wr;
L.polyfills = xr;
L.WretchError = fe;
class Yr extends Error {
  constructor(t, o, n, s, A) {
    super(t);
    S(this, "statusCode");
    S(this, "endpoint");
    S(this, "args");
    S(this, "response");
    this.name = "ApiError", this.statusCode = o, this.endpoint = n, this.args = s, this.response = A;
  }
}
class J extends Yr {
  constructor(r, t, o, n) {
    super(`Client error ${r} occurred while fetching ${t}`, r, t, o, n), this.name = "Api4xxError";
  }
}
class Fr extends J {
  constructor(r, t, o) {
    super(404, r, t, o), this.name = "Api404Error";
  }
}
class kr extends J {
  constructor(r, t, o) {
    super(400, r, t, o), this.name = "Api400Error";
  }
}
class Xr {
  constructor(r = {}) {
    S(this, "logger");
    S(this, "notFoundLogLevel");
    S(this, "badRequestLogLevel");
    S(this, "other4xxLogLevel");
    this.logger = r.logger, this.notFoundLogLevel = r.notFoundLogLevel || "info", this.badRequestLogLevel = r.badRequestLogLevel || "warn", this.other4xxLogLevel = r.other4xxLogLevel || "warn";
  }
  log(r, t, o) {
    this.logger && this.logger[r](t, o);
  }
  async handleApiError(r, t, o) {
    if (!(r instanceof Response))
      throw r;
    const { status: n } = r;
    if (n === 404) {
      const s = new Fr(t, o, r);
      return this.log(this.notFoundLogLevel, s.message, {
        args: o,
        endpoint: t,
        statusCode: n
      }), null;
    }
    if (n === 400) {
      const s = new kr(t, o, r);
      return this.log(this.badRequestLogLevel, s.message, {
        args: o,
        endpoint: t,
        statusCode: n
      }), null;
    }
    if (n >= 400 && n < 500) {
      const s = new J(n, t, o, r);
      return this.log(this.other4xxLogLevel, s.message, {
        args: o,
        endpoint: t,
        statusCode: n
      }), null;
    }
    throw r;
  }
}
const Jr = (e, r) => {
  const t = new Xr(r);
  return e.catcher(404, async (o) => (await t.handleApiError(o.response, o.url), null)).catcher(400, async (o) => (await t.handleApiError(o.response, o.url), null)).catcher(401, async (o) => (await t.handleApiError(o.response, o.url), null)).catcher(403, async (o) => (await t.handleApiError(o.response, o.url), null)).catcherFallback(async (o) => {
    if (o.status >= 400 && o.status < 500)
      return await t.handleApiError(o.response, o.url), null;
    throw o;
  });
}, Hr = (e) => e ? e.split(",").map((r) => r.trim()).filter(Boolean).join(",") : "", Qr = (e) => {
  const r = Object.entries(e).filter(([, t]) => t !== void 0).sort(([t], [o]) => t.localeCompare(o)).map(([t, o]) => [t, String(o)]);
  return new URLSearchParams(r).toString();
}, Zr = async (e, r, t) => {
  var p;
  const { apiKey: o, countryCode: n, deviceType: s, offerIds: A, offerLimit: g, sortBy: C, subdivisionCode: i, vcId: a } = r;
  if (!o)
    throw (p = t == null ? void 0 : t.logger) == null || p.error("No apiKey provided"), new Error("No apiKey provided.");
  const f = a ? { variationContainerId: a } : A ? { offerIds: Hr(A) } : void 0, d = Qr({
    ...f,
    ...s && { deviceType: s },
    ...g ? { limit: g } : {},
    ...C ? { sort: C } : {}
  }), l = new URL(`${e}/v1/offers?${d}`);
  return Jr(
    L(l.toString(), {
      headers: {
        accept: "application/json",
        "api-key": o,
        "content-type": "application/json",
        ...n && { "country-code": n },
        ...i && { "subdivision-code": i },
        ...(t == null ? void 0 : t.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    t
  ).get().json();
}, ue = async (e = "https://offers-delivery-api-stg.core.occloud.io", r, t = {}) => {
  try {
    return await Zr(e, r, t);
  } catch (o) {
    throw t.logger && t.logger.error(o), o;
  }
}, de = ({ apiKey: e, offerIds: r, vcId: t }) => ["offers-carousel", e, r ? "offerIds" : "vcId", r || t], _r = (e) => e && e.map((r) => {
  var t, o;
  return "code" in r.bookmaker && typeof r.bookmaker.code == "string" && (r.bookmaker.feedsCode = r.bookmaker.code, delete r.bookmaker.code), "clickoutUrl" in r && typeof ((t = r.clickoutUrl) == null ? void 0 : t.url) == "string" && (r.clickOutUrl = (o = r.clickoutUrl) == null ? void 0 : o.url, delete r.clickoutUrl), "isTermsExpanded" in r && typeof r.isTermsExpanded == "boolean" && (r.autoExpandedTermsAndConditions = r.isTermsExpanded, delete r.isTermsExpanded), r;
}), $r = ({
  dataApiEndpoint: e,
  ...r
}) => Be({
  queryFn: () => ue(e, r, {
    logger: console
  }),
  queryKey: de(r),
  select: (t) => _r(t)
}), et = "data:image/png;base64,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", rt = "data:image/png;base64,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", W = /* @__PURE__ */ new Map(), he = (e) => (r) => {
  r.preventDefault();
  const t = W.get("disableAnalytics"), o = W.get("analyticsDataLayer");
  !t && Array.isArray(o) && o.push({
    action: "Clickout - Powered by",
    category: "Widget",
    event: "powered_by_clickout",
    page: window.location.href,
    variation: "default"
  }), window.open(e, "_blank", "noopener noreferrer");
}, tt = () => /* @__PURE__ */ q(k, { children: [
  "Powered by",
  /* @__PURE__ */ c(
    "a",
    {
      href: "https://www.oddschecker.com/us/",
      onClick: he("https://www.oddschecker.com/us/"),
      rel: "noopener noreferrer nofollow",
      target: "_blank",
      children: /* @__PURE__ */ c("img", { alt: "oddschecker", height: "20", src: rt, width: "107" })
    }
  )
] }), ot = () => /* @__PURE__ */ q(k, { children: [
  "21+ Gambling Problem? Call 1-800-GAMBLER. Powered by",
  /* @__PURE__ */ c(
    "a",
    {
      href: "https://confidonetwork.com/",
      onClick: he("https://confidonetwork.com/"),
      rel: "noopener noreferrer nofollow",
      target: "_blank",
      children: /* @__PURE__ */ c("img", { alt: "confido", height: "20", src: et, width: "90" })
    }
  )
] }), nt = ({
  analyticsDataLayer: e,
  disableAnalytics: r,
  poweredBy: t = ""
}) => {
  switch (W.set("disableAnalytics", r), W.set("analyticsDataLayer", e), t) {
    case "confido":
      return /* @__PURE__ */ c(ot, {});
    case "ocus":
      return /* @__PURE__ */ c(tt, {});
    default:
      return "";
  }
}, st = (e, r, t) => {
  const o = e(r);
  return o === r ? t : o;
}, At = () => typeof window < "u" ? window.dataLayer : [], gt = (e) => {
  const {
    analyticsDataLayer: r = At(),
    analyticsImpressionEventData: t,
    apiKey: o,
    clickoutService: n,
    clickoutServiceUrl: s,
    deviceType: A,
    disableAnalytics: g = !1,
    fullPageUrl: C,
    gtmId: i = null,
    pageUrl: a,
    poweredBy: f,
    recommendedMarketId: d
  } = e, { trackImpression: l } = Dr(g, r), w = x(null), p = x(!1);
  zr(w, () => {
    p.current || (p.current = !0, l({
      action: "impression",
      category: "Widget",
      event: "widget_impression",
      label: "widget_impression",
      page: window.location.href,
      variation: "default",
      widgetType: "offers",
      ...t ?? {}
    }));
  });
  const { data: y } = $r(e), m = x(null), { t: G } = We("label"), I = st(G, "CX_VIEW_T&CS", "View T&Cs"), u = nt({ analyticsDataLayer: r, disableAnalytics: g, poweredBy: f }), h = Array.isArray(y), M = Ye({
    apiKey: o,
    clickoutOrigin: "offers-carousel",
    clickoutServiceUrl: s,
    deviceType: A,
    fullPageUrl: C,
    gtmId: i,
    offers: y,
    pageUrl: a,
    recommendedMarketId: d,
    shouldUseClickoutService: n === "OFFERS_CLICKOUT_SERVICE"
  });
  return /* @__PURE__ */ c(
    Vr,
    {
      containerRef: w,
      offerCount: M && M.length || 0,
      poweredBy: u,
      ref: m,
      children: h && M.map((E, z) => /* @__PURE__ */ c(
        ce,
        {
          analyticsDataLayer: r,
          disableAnalytics: g,
          isOnlyChild: M.length === 1,
          offerIndex: z,
          termsCtaLabel: I,
          ...E,
          ...z === 0 && { ref: m },
          placeholders: e.placeholders
        },
        E.id
      ))
    }
  );
};
var Ct = typeof b == "object" && b && b.Object === Object && b, It = typeof self == "object" && self && self.Object === Object && self, it = Ct || It || Function("return this")(), te = it.Symbol, oe = te ? te.prototype : void 0;
oe && oe.toString;
var ct = typeof b == "object" && b && b.Object === Object && b, lt = typeof self == "object" && self && self.Object === Object && self, at = ct || lt || Function("return this")(), ne = at.Symbol, se = ne ? ne.prototype : void 0;
se && se.toString;
(function(e) {
  typeof globalThis != "object" && (this ? r() : (e.defineProperty(e.prototype, "_T_", {
    configurable: !0,
    get: r
  }), _T_));
  function r() {
    var t = this || self;
    t.globalThis = t, delete e.prototype._T_;
  }
})(Object);
const ft = (e, r) => r.skipDedupe || r.method !== "GET", ut = (e, r) => r.method + "@" + e, dt = (e) => e.clone(), pe = ({ skip: e = ft, key: r = ut, resolver: t = dt } = {}) => {
  const o = /* @__PURE__ */ new Map();
  return (n) => (s, A) => {
    if (e(s, A))
      return n(s, A);
    const g = r(s, A);
    if (!o.has(g))
      o.set(g, []);
    else
      return new Promise((C, i) => {
        o.get(g).push([C, i]);
      });
    try {
      return n(s, A).then((C) => (o.get(g).forEach(([i]) => i(t(C))), o.delete(g), C)).catch((C) => {
        throw o.get(g).forEach(([, i]) => i(C)), o.delete(g), C;
      });
    } catch (C) {
      return o.delete(g), Promise.reject(C);
    }
  };
}, ht = (e, r) => r.skipCache || r.method !== "GET", pt = (e, r) => r.method + "@" + e, wt = () => !1, yt = () => null, mt = (e) => e.ok, vt = ({ throttle: e = 1e3, skip: r = ht, key: t = pt, clear: o = wt, invalidate: n = yt, condition: s = mt, flagResponseOnCacheHit: A = "__cached" } = {}) => {
  const g = /* @__PURE__ */ new Map(), C = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), a = (d) => {
    e && !i.has(d) && (i.add(d), setTimeout(() => {
      i.delete(d);
    }, e));
  }, f = (d) => (l, w) => {
    const p = t(l, w);
    let y = n(l, w);
    if (y && (y instanceof Array || (y = [y]), y.forEach((m) => {
      typeof m == "string" ? g.delete(m) : m instanceof RegExp && g.forEach((G, I) => {
        m.test(I) && g.delete(I);
      });
    })), o(l, w) && g.clear(), r(l, w))
      return d(l, w);
    if (i.has(p)) {
      if (g.has(p)) {
        const m = g.get(p).clone();
        return A && Object.defineProperty(m, A, {
          value: p,
          enumerable: !1
        }), Promise.resolve(m);
      } else if (C.has(p))
        return new Promise((m, G) => {
          C.get(p).push([m, G]);
        });
    }
    return C.has(p) || C.set(p, []), a(p), d(l, w).then((m) => (s(m.clone()) && g.set(p, m.clone()), C.get(p).forEach(([G]) => G(m.clone())), C.delete(p), m)).catch((m) => {
      throw C.get(p).forEach(([, G]) => G(m)), C.delete(p), m;
    });
  };
  return f.cacheResponse = function(d, l) {
    a(d), g.set(d, l);
  }, f.cache = g, f.inflight = C, f.throttling = i, f;
}, Gt = (e, r) => e * r, Rt = (e) => e && e.ok, we = ({ delayTimer: e = 500, delayRamp: r = Gt, maxAttempts: t = 10, until: o = Rt, onRetry: n = null, retryOnNetworkError: s = !1, resolveWithLatestResponse: A = !1, skip: g } = {}) => (C) => (i, a) => {
  let f = 0;
  if (g && g(i, a))
    return C(i, a);
  const d = (l, w) => Promise.resolve(o(l, w)).then((p) => p ? l && A ? l : w ? Promise.reject(w) : l : (f++, !t || f <= t ? new Promise((y) => {
    const m = r(e, f);
    setTimeout(() => {
      typeof n == "function" ? Promise.resolve(n({
        response: l,
        error: w,
        url: i,
        options: a
      })).then((G = {}) => {
        var I, u;
        y(C((I = G && G.url) !== null && I !== void 0 ? I : i, (u = G && G.options) !== null && u !== void 0 ? u : a));
      }) : y(C(i, a));
    }, m);
  }).then(d).catch((y) => {
    if (!s)
      throw y;
    return d(null, y);
  }) : l && A ? l : Promise.reject(w || new Error("Number of attempts exceeded."))));
  return C(i, a).then(d).catch((l) => {
    if (!s)
      throw l;
    return d(null, l);
  });
};
L().middlewares([
  pe(),
  we({
    delayRamp: (e, r) => e * r,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  }),
  vt({
    key: (e, r) => r.headers["X-Cache-Key"],
    throttle: 1e3 * 60 * 60 * 24 * 7
    // 7 days (max safe is ~24.8 days)
  })
]);
L().middlewares([
  pe(),
  we({
    delayRamp: (e, r) => e * r,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  })
]);
function Et(e = {}) {
  return new Oe.QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay(r) {
          return r * 100;
        }
      }
    },
    ...e
  });
}
const Bt = async (e, r) => {
  const t = Et();
  try {
    await t.prefetchQuery({
      queryFn: () => ue(r, e, { nocache: e.nocache }),
      queryKey: de(e)
    });
  } catch {
  }
  return {
    dehydratedState: Ve(t)
  };
}, Mt = (e) => new Ue({
  defaultOptions: {
    queries: {
      gcTime: e ? 0 : void 0,
      refetchOnMount: !!e,
      staleTime: e ? 0 : 1 / 0
    }
  }
});
function Vt({
  dehydratedState: e,
  loadingSlot: r,
  nocache: t,
  ...o
}) {
  const [n] = X(() => {
    const s = Mt(t);
    return ze(s, e), s;
  });
  return /* @__PURE__ */ c(De, { client: n, children: /* @__PURE__ */ c(xe, { i18nInstance: o.i18n, children: /* @__PURE__ */ c(Te, { fallback: r ?? /* @__PURE__ */ c("div", { children: "Loading..." }), children: /* @__PURE__ */ c(gt, { ...o }) }) }) });
}
export {
  Vt as default,
  Bt as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
